import type { OrderFormItem } from '../../../../../core/requests/checkout'
import type { OrderFormItemWithAssemblyItems } from '../typings'

const checkItemIsLoading = (item: Partial<OrderFormItem>) => {
  return !item.uniqueId
}

// TODO: move this logic to sales-app-server after migrating simulation and orderForm apis
export const groupItemsWithAssemblyItems = (
  cartItems: Array<OrderFormItem & { index: number }>
) => {
  const group: OrderFormItemWithAssemblyItems[] = []

  cartItems.forEach((cartItem, index) => {
    if (checkItemIsLoading(cartItem)) {
      group.push({
        orderFormItem: {
          item: cartItem,
          index,
        },
        assemblyItems: [],
      })
    } else if (cartItem.parentItemIndex === null) {
      const assemblyItems = cartItems.filter((item) => {
        return item.parentItemIndex === index
      })

      group.push({
        orderFormItem: {
          item: cartItem,
          index,
        },
        assemblyItems: assemblyItems.map((item) => ({
          item,
          index: cartItems.findIndex((el) => el.id === item.id),
        })),
      })
    }
  })

  return group
}
